export const PATHS = {
  LOGIN: "/login", // Mobile only
  REGISTER: "/register", // Mobile only
  // Home
  HOME: "/",
  AUTH_ERROR: "/authError",
  FORGOT_PASSWORD: "/forgotPassword",
  RESET_PASSWORD: "/resetPassword",
  UPDATES: "/updates",
  BLOG: "/blog",
  CHANGELOG: "/changelog",
  NEWSLETTER: "/newsletter",
  AFFILIATE: "/affiliate",
  COMPARE: "/compare",
  ABOUT_US: "/aboutUs",
  TOOLS: "/tools",
  CONTACT: "/contact",
  // Legal
  PRIVACY_POLICY: "/privacyPolicy",
  TERMS_OF_SERVICE: "/termsOfService",
  PRICING: "/pricing",
  // Dashboard
  DASHBOARD: "/dashboard",
  NEW_USER: "/dashboard/newUser",
  CALENDAR: "/dashboard/calendar",
  SETTINGS: "/dashboard/settings",
  HEALTH_AREAS: "/dashboard/health-areas",
  HEALTH_AREA_MANAGE: "/dashboard/health-area/manage",
  GOALS: "/dashboard/goals",
  GOAL_MANAGE: "/dashboard/goal/manage",
  ROUTINES: "/dashboard/routines",
  ROUTINE_MANAGE: "/dashboard/routine/manage",
  LIBRARY: "/dashboard/library",
  LIBRARY_HEALTH_AREA: "/dashboard/library/health-area",
  ACCOUNT: "/dashboard/account",
  PROFILE: "/dashboard/profile",
  CALENDAR_SETTINGS: "/dashboard/calendarSettings",
  NOTIFICATION_SETTINGS: "/dashboard/notificationSettings",
} as const;

// Translation keys for page labels - these will be resolved at runtime
export const PATH_LABEL_KEYS = {
  [PATHS.REGISTER]: "auth.register.title",
  [PATHS.LOGIN]: "auth.login.title",
  [PATHS.HEALTH_AREAS]: "sidebar.health_areas",
  [PATHS.HEALTH_AREA_MANAGE]: "Manage Health Area", // Keep as is for now
  [PATHS.GOALS]: "sidebar.goals",
  [PATHS.GOAL_MANAGE]: "Manage Goal", // Keep as is for now
  [PATHS.ROUTINES]: "sidebar.routines",
  [PATHS.ROUTINE_MANAGE]: "Manage Routine", // Keep as is for now
  [PATHS.LIBRARY]: "sidebar.library",
  [PATHS.ACCOUNT]: "pages.account.title",
  [PATHS.PROFILE]: "pages.profile.title",
  [PATHS.CALENDAR_SETTINGS]: "pages.calendar_settings.title",
  [PATHS.NOTIFICATION_SETTINGS]: "pages.notification_settings.title",
  [PATHS.CONTACT]: "Contact", // Keep as is for now
} as const;

// Legacy PATH_LABELS for backward compatibility - will be deprecated
export const PATH_LABELS = {
  [PATHS.REGISTER]: "Register",
  [PATHS.LOGIN]: "Login",
  [PATHS.HEALTH_AREAS]: "My Health Areas",
  [PATHS.HEALTH_AREA_MANAGE]: "Manage Health Area",
  [PATHS.GOALS]: "My Goals",
  [PATHS.GOAL_MANAGE]: "Manage Goal",
  [PATHS.ROUTINES]: "My Routines",
  [PATHS.ROUTINE_MANAGE]: "Manage Routine",
  [PATHS.LIBRARY]: "Health Areas",
  [PATHS.ACCOUNT]: "My Account",
  [PATHS.PROFILE]: "My Profile",
  [PATHS.CALENDAR_SETTINGS]: "Calendar Settings",
  [PATHS.NOTIFICATION_SETTINGS]: "Notification Settings",
  [PATHS.CONTACT]: "Contact",
} as const;
